"use client";

import * as React from "react";
import { Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const deliverables = [{
  title: "Risk Register",
  description: "Proactive identification and mitigation strategies for project-critical variables, ensuring stability and foresight."
}, {
  title: "Project Schedule",
  description: "Dynamic, milestone-driven timelines ensuring on-time delivery across complex workstreams and ServiceNow migrations."
}, {
  title: "Resource Allocation",
  description: "Strategic deployment of senior-level expertise to maximize operational efficiency without the overhead of junior staff."
}, {
  title: "Stakeholder Matrix",
  description: "Comprehensive communication mapping for seamless alignment across all organizational levels and executive leadership."
}, {
  title: "Milestone Tracking",
  description: "Outcome-based progress monitoring tied to specific, measurable business results and milestone payment models."
}, {
  title: "Quality Assurance",
  description: "Rigorous standards and ServiceNow-aligned protocols for world-class implementation and field service integrity."
}];
export default function WhatYouGet() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="87030" id="the-results-framework" className="dark bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`mx-auto max-w-2xl text-center transition-all duration-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="font-sans text-4xl font-bold tracking-tighter text-foreground sm:text-5xl md:text-6xl">
            The Results Framework
          </h2>
          <p className="mt-4 text-xl text-muted-foreground font-sans">
            Our architectural approach to project management ensures world-class delivery through precise, outcome-based deliverables.
          </p>
        </div>

        <div className="mx-auto mt-16 max-w-5xl">
          <div className="grid gap-6 md:grid-cols-2 lg:gap-8">
            {deliverables.map((item, i) => <div key={i} data-index={i} className={`flex items-start gap-4 rounded-none border border-primary/30 bg-secondary/10 p-6 shadow-none transition-all duration-500 hover:border-primary hover:bg-secondary/20 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-none bg-primary text-primary-foreground shadow-sm">
                  <Check className="h-5 w-5" strokeWidth={3} />
                </div>
                <div>
                  <h3 className="font-sans text-xl font-bold tracking-tight text-foreground">
                    {item.title}
                  </h3>
                  <p className="mt-2 leading-relaxed text-muted-foreground font-sans">
                    {item.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}